export default __webpack_public_path__ + "static/media/speedometer.99576a54.svg";